import styled from "@emotion/styled";
import { ExpertEducationRecord } from "@src/api/types";
import moment from "moment";

export const ProfileEducationItem = ({
	school,
	major,
	start,
	end,
	isCurrent,
}: ExpertEducationRecord) => (
	<Wrapper>
		<div className="top">
			<div className="title-box">{school}</div>
			{start && (
				<div className="duration">
					{isCurrent
						? `${moment(start).format("YYYY.MM")} ~ 현재`
						: `${moment(start).format("YYYY.MM")} ~ ${moment(end).format("YYYY.MM")}`}
				</div>
			)}
		</div>
		<div className="content">
			<div>{major}</div>
		</div>
	</Wrapper>
);

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;

	.one-point {
		color: var(--primary);
		font-size: 16px;
		font-weight: bold;
	}

	.top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: flex-start;

		.title-box {
			color: var(--card-bg);
			font-size: 20px;
			font-weight: 700;
			line-height: normal;
		}

		.duration {
			white-space: pre-wrap;
			font-weight: 700;
		}
	}

	.content {
		display: flex;
		flex-direction: column;
		margin-top: 12px;

		color: var(--desc-gray);
		font-size: 16px;
		font-weight: 400;
		line-height: 28px;

		white-space: pre-wrap;
	}
`;
